/** Symbol-to-name map for common organic chemistry elements. */
const elementNames: Record<string, string> = {
    H: "Hydrogen", He: "Helium",
    Li: "Lithium", Be: "Beryllium", B: "Boron", C: "Carbon", N: "Nitrogen",
    O: "Oxygen", F: "Fluorine", Ne: "Neon",
    Na: "Sodium", Mg: "Magnesium", Al: "Aluminum", Si: "Silicon", P: "Phosphorus",
    S: "Sulfur", Cl: "Chlorine", Ar: "Argon",
    K: "Potassium", Ca: "Calcium",
    Ti: "Titanium", Cr: "Chromium", Mn: "Manganese", Fe: "Iron",
    Co: "Cobalt", Ni: "Nickel", Cu: "Copper", Zn: "Zinc",
    Ga: "Gallium", Ge: "Germanium", As: "Arsenic", Se: "Selenium",
    Br: "Bromine", Kr: "Krypton",
    Ag: "Silver", Sn: "Tin", I: "Iodine", Xe: "Xenon",
    Pt: "Platinum", Au: "Gold", Hg: "Mercury", Pb: "Lead",
    At: "Astatine", Ts: "Tennessine",
    Ac: "Actinium", Pr: "Praseodymium", Cn: "Copernicium",
};

export const getElementName = (symbol: string): string | undefined => elementNames[symbol];
